import clsx from "clsx";
import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <div
      className={clsx(
        // Base layout & dimensions
        "min-h-screen flex flex-col items-center justify-center p-4"
      )}
    >
      <div className="text-center space-y-6">
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700">Page Not Found</h2>
        <p className="text-gray-600 max-w-md">
          Sorry, we couldn't find the page you're looking for. It might have been moved, deleted, or you entered the
          wrong URL.
        </p>
        <Link
          to="/"
          className={clsx(
            // Base layout & dimensions
            "inline-block px-6 py-3",
            // Typography & text styling
            "text-white",
            // Visual appearance & backgrounds
            "bg-pink-600 rounded-xl",
            // User interaction states
            "hover:bg-pink-700",
            // Transitions
            "transition-colors"
          )}
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
